import { Box } from "@mui/system";
import { Chart, Line, Point, Tooltip, Legend, registerGeometryLabel, GeometryLabel, Axis, Interaction } from 'bizcharts';
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import DownloadButton from "../Common/DownloadButton";

const MultiLineChart = (props) => {
    const [data, setData] = useState([]);

    const csv = props.csv;
    const { readString } = usePapaParse();

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                setData(results.data);
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    class CustomLabel extends GeometryLabel {
        getLabelId(mappingData) {
            const geometry = this.geometry;
            const type = geometry.type;
            const xScale = geometry.getXScale();
            const yScale = geometry.getYScale();
            const origin = mappingData['_origin']; // 原始数据

            let labelId = geometry.getElementId(mappingData);
            if (type === 'line' || type === 'area') {
                labelId += ` ${origin[xScale.field]}`;
            } else if (type === 'path') {
                labelId += ` ${origin[xScale.field]}-${origin[yScale.field]}`;
            }
            if (labelId.includes('2014') || labelId.includes('2017')) {
                return '';
            } else {
                return labelId;
            }
        }
    }
    registerGeometryLabel('custom', CustomLabel);

    useEffect(() => {
        handleReadString();
    }, []);

    let scale = {};

    const transform = [];
    let color = ['Food commodity', ['#FFCE3A']];
    if (props.commodity) {
        color = ['status', '#00B289-#FFCE3A'];
        data.filter(d => d['Food commodity'] === props.filter).forEach(d => {
            transform.push({
                status: '≤MRL',
                year: 2014,
                value: d['% Between LOQ and LL2014']
            });
            transform.push({
                status: '≤MRL',
                year: 2017,
                value: d['% Between LOQ and LL 2017']
            });
            transform.push({
                status: '≤MRL',
                year: 2020,
                value: d['% between LOQ and LL samples']
            });
            transform.push({
                status: '>MRL',
                year: 2014,
                value: d['% Above LL samples-2014']
            });
            transform.push({
                status: '>MRL',
                year: 2017,
                value: d['% Above LL samples - 2017']
            });
            transform.push({
                status: '>MRL',
                year: 2020,
                value: d['% Above LL samples']
            });
        });

        const max = Math.max(...transform.map(d => d.value ? d.value : 0));
        scale = {
            value: {
                min: 0,
                max: max + (max > 5 ? 5 : 2)
            },
        }

    } else {
        data.filter(d => d.Type === props.filter).forEach(d => {

            transform.push({
                'Food commodity': d['Food commodity'],
                year: 2014,
                value: d['2014']
            });
            transform.push({
                'Food commodity': d['Food commodity'],
                year: 2017,
                value: d['2017']
            });
            transform.push({
                'Food commodity': d['Food commodity'],
                year: 2020,
                value: d['2020']
            });
        });
        scale = {
            value: { min: 0 },
            year: {
                min: 2014,
                max: 2020
            }
        }
    }

    const [canvas, setCanvas] = useState(undefined);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= 900)
        }
        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })

    let padding = 'auto'
    if (!props.commodity) {
        if (isMobile) {
            padding = [20, 70, 50, 30];
        } else {
            padding = [50, 100, 50, 50];
        }
    }

    return (
        <Box>
            <Box display='flex' justifyContent='space-between'>
                <p style={{ fontFamily: 'Roboto Condensed, sans-serif', width: '100%', marginBottom: '.5rem' }}>{props.title}</p>
                <DownloadButton canvas={canvas} fileName={props.title} csv={data} isRaw />
            </Box>

            <Chart
                scale={scale}
                padding={padding}
                autoFit
                height={props.commodity ? 300 : 500}
                data={transform}
                onGetG2Instance={chartInstance => {
                    setCanvas(chartInstance.canvas);
                }}
            >
                <Line position="year*value" color={color} label={[
                    "Food commodity", {
                        type: 'custom',
                        offsetX: 10,
                        offsetY: 10,
                        position: 'left',
                        style: {
                            textAlign: 'start',
                            fontSize: 13,
                        },
                    }
                ]} />
                <Tooltip shared={props.commodity ? true : false} showCrosshairs region={null} g2-tooltip-list-item={{ display: 'flex' }} itemTpl={'<li style="padding: 10px 0" data-index={index}>'
                    + '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>'
                    + '{name}: {value}%'
                    + '</li>'} />
                <Legend visible={props.commodity ? true : false} position={props.legendPosition} />
                <Axis name="value" label={{
                    formatter: (a) => {
                        return a + '%';
                    }
                }} />
                <Axis name='year' label={{
                    formatter: (a) => {
                        if (a !== '2014' && a !== '2017' && a !== '2020') {
                            return '';
                        } else {
                            return a;
                        }

                    }
                }} />
                {!props.commodity && <Interaction type="element-highlight" />}
            </Chart>
        </Box >
    )
}

export default MultiLineChart;
